import { ToastrService } from 'ngx-toastr';
import { MediaCategory } from '../../../shared/enums/enums';
import { SharedService } from '../../../shared/services/shared.service';

export class CustomUploadAdapter {
  loader: any;
  sharedService: SharedService;
  toastr: ToastrService;
  constructor(
    loader: any,
    sharedService: SharedService,
    toastr: ToastrService
  ) {
    this.loader = loader;
    this.sharedService = sharedService;
    this.toastr = toastr;
  }

  upload() {
    return this.loader.file.then((file: any) => {
      return new Promise((resolve, reject) => {
        if (file.size > 1024 * 1024) {
          this.toastr.error('File size must be less than 1 MB');
          reject();
        }
        if (file) {
          this.sharedService
            .getMediaSignedUrl({
              fileName: file.name,
              contentType: file.type,
              category: MediaCategory.IMAGE,
            })
            .subscribe({
              next: (data: {
                contentUrl: string;
                key: string;
                uploadUrl: string;
              }) => {
                this.sharedService.uploadFile(data.uploadUrl, file).subscribe({
                  next: () => {
                    resolve({
                      default: data.contentUrl,
                    });
                  },
                  error: (err) => {
                    console.error(err);
                    reject(err);
                  },
                });
              },
              error: (err) => {
                console.error(err);
                reject(err);
              },
            });
        }
      });
    });
  }
}
